<pages-container
  [title]="'competency.competency'"
  [subtitle]="'competency.add'"
  [icon]="'psychology'"
  [showSearch]="false">

  <div back-button>
    <button class="back-button" mat-icon-button [routerLink]="'/pages/settings/competency'">
      <mat-icon>arrow_back</mat-icon>
    </button>
  </div>

  <div buttons>
    <button mat-raised-button
            class="mat-white-bg"
            [disabled]="this.competencyForm().invalid()"
            (click)="addCompetency()">
      <span>{{'main.add' | translate}}</span>
    </button>
  </div>

  <div main-content>
    <div class="competency-form">
      <mat-form-field>
        <mat-label>{{'competency.title' | translate}}</mat-label>
        <input matInput [formField]="competencyForm.title">
        @if (competencyForm.title().invalid() && competencyForm.title().touched()) {
          <mat-error>
            @for (error of competencyForm.title().errors(); track error) {
              {{error.message | translate}}
            }
          </mat-error>
        }
      </mat-form-field>
      <div class="choose-color">
        <mat-label>{{'competency.choose_color' | translate}} *</mat-label>
        <fuse-material-color-picker (onValueChange)="onSettingsChange($event)">
        </fuse-material-color-picker>
      </div>
      <mat-card>
        <mat-card-header>
          <mat-card-title>{{'competency.skills' | translate}} *</mat-card-title>
          <mat-card-subtitle>{{'competency.skills_required' | translate}}</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <div class="skills-list" cdkDropList (cdkDropListDropped)="drop($event)">
            @for (skill of competencyModel().skills; track $index) {
              <div class="skill" cdkDrag cdkDragLockAxis="y">
                <mat-form-field class="skill-title">
                  <mat-label>{{'competency.skill_title' | translate}}</mat-label>
                  <input matInput id="{{$index}}_skill" [formField]="competencyForm.skills[$index].title">
                  @if (competencyForm.skills[$index].title().invalid() && competencyForm.skills[$index].title().touched()) {
                    <mat-error>
                      @for (error of competencyForm.skills[$index].title().errors(); track error) {
                        {{error.message | translate}}
                      }
                    </mat-error>
                  }
                </mat-form-field>
                <button mat-raised-button
                        class="mat-white-bg remove-skill-button"
                        (click)="removeSkill($index)"
                        title="{{'competency.removeSkill' | translate}}">
                  <mat-icon>remove</mat-icon>
                </button>
              </div>
            }
          </div>
          <button mat-raised-button
                  class="mat-white-bg"
                  (click)="addSkill()">
            <span>{{'competency.add_skill' | translate}}</span>
          </button>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

</pages-container>
